import { batch } from 'react-redux';
import { toast } from 'react-toastify';

import { useAppDispatch } from 'redux/store/store.types';
import { ApiGetRequest } from 'types';
import { getApiErrorMessage } from 'utils';

import { useCreateChatMutation, useLazySearchUsersQuery } from '../api/app-chat.api';
import { addChat, setActiveChat } from '../store/app-chat.slice';
import { CreateChatPayload, IChatUser } from '../types/app-chat.type';

interface UseChat {
  crateChatHandler: (payload: CreateChatPayload) => Promise<boolean>;
  searchUsersHandler: (payload: ApiGetRequest) => Promise<Array<IChatUser>>;
}

export const useChat = (): UseChat => {
  const dispatch = useAppDispatch();

  const [createChatQuery] = useCreateChatMutation();
  const [searchUsersQuery] = useLazySearchUsersQuery();

  const crateChatHandler = async (payload: CreateChatPayload) => {
    const { data: response, error } = await createChatQuery(payload);
    const isError = error || !response?.data;
    if (isError) {
      toast.error(getApiErrorMessage(error) || 'Failed to create chat!');
    } else {
      batch(() => {
        dispatch(addChat(response.data));
        dispatch(setActiveChat(response.data.id));
      });
    }

    return !isError;
  };

  const searchUsersHandler = async (payload: ApiGetRequest) => {
    const { data: response, error } = await searchUsersQuery(payload);
    const isError = error || !response?.data;
    if (isError) {
      return [];
    }

    return response.data;
  };

  return { crateChatHandler, searchUsersHandler };
};
